module.exports = __webpack_public_path__ + "img/icon_member_on.d3c5c3c5.svg";